import { render, staticRenderFns } from "./IDPSuggestions.vue?vue&type=template&id=6f2e70ce"
import script from "./IDPSuggestions.vue?vue&type=script&lang=js"
export * from "./IDPSuggestions.vue?vue&type=script&lang=js"
import style0 from "./IDPSuggestions.vue?vue&type=style&index=0&id=6f2e70ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports